import { parseSearchParams } from '@/routes/helpers/parse-search-params';

export const useProjectListingsSectionParams = () => {
  return parseSearchParams({
    listingsTab: 'all',
  });
};
